export { default } from './empty-content';
